import axios from "axios";
import { io } from "socket.io-client";

import store from "../redux/store"; // adjust to your actual path
import { logout } from "../redux/features/authSlice";
import { setExpiredModalOpen } from "../redux/features/expiredModalSlice";

// Toggle environments
const isProduction = true;
const isProductionSocket = true;

// URLs
const localBaseURL = "http://localhost:5005";
const prodBaseURL = "https://lokalai-may25-production.vercel.app";

const localSocketURL = "http://localhost:6005/";
const prodSocketURL = "https://socket-lokalai-production-may25.onrender.com/";

// Final resolved URLs
export const baseURL = isProduction ? prodBaseURL : localBaseURL;
export const socketEndpoint = isProductionSocket
  ? prodSocketURL
  : localSocketURL;

// Create socket connection
export const socketId = io(socketEndpoint, {
  transports: ["websocket"],
});

// Axios clients
export const publicClient = axios.create({
  baseURL: `${baseURL}/api`,
  headers: {
    "Content-Type": "application/json",
  },
});

export const privateClient = axios.create({
  baseURL: `${baseURL}/api`,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add token interceptor
privateClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("actkn");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Refresh logic
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

privateClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers["Authorization"] = "Bearer " + token;
            return privateClient(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const refreshToken = localStorage.getItem("rftkn");
        const res = await publicClient.post("/v2/operator/refresh", {
          refreshToken,
        });

        const newToken = res.data.token;
        localStorage.setItem("actkn", newToken);

        privateClient.defaults.headers.common["Authorization"] =
          "Bearer " + newToken;

        processQueue(null, newToken);

        return privateClient(originalRequest);
      } catch (err) {
        processQueue(err, null);
        store.dispatch(logout());
        store.dispatch(setExpiredModalOpen(true));
        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

// privateClient.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response && error.response.status === 401) {
//       console.log("🔴 AXIOS INTERCEPTOR TRIGGERED", error?.response?.status);

//       store.dispatch(logout());

//       store.dispatch(setExpiredModalOpen(true));
//       localStorage.removeItem("actkn");
//     }

//     return Promise.reject(error);
//   }
// );
